module.exports = __webpack_public_path__ + "static/img/M-500-ANTIQUE-WHITE.c7c20b6.png";


//////////////////
// WEBPACK FOOTER
// ./static/materials/cortina/M-500-ANTIQUE-WHITE.png
// module id = 82AB
// module chunks = 0